import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { convertDate, defineTicketNumber } from '../../Helpers/helpers';

import GlobalNotes from '../CommonComponents/GlobalNotes';

import { GetAuth } from '../../Auth/AuthProvider';

import { NoHeaderTableUpdate } from '../../Helpers/requests';

import { Button, Box, Typography, Grid } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

import CircleIcon from '@mui/icons-material/Circle';
import { ticketTabStyle } from '../shared/commonStyle';

function RepairArchive() {
  const [data, setData] = useState([]); //data displayed in datagrid
  const [page, setPage] = useState(0); //Active page of table - starts at 0!
  const [filter, setFilter] = useState([]); //Current applied filter modal
  const [sort, setSort] = useState([]); //Current applied sorting modal
  const [loading, setLoading] = useState(false); //Loading indicator - used by datagrid
  const [, setActiveRow] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize, setPageSize] = useState(20); //Number of rows to display
  const [totalRows, setTotalRows] = useState(0); //Total Number of rows in set
  const [updateData, setUpdateData] = useState(0); //Increment to force update dataset
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const navigateNew = useNavigate();

  const [infoPlateData, setInfoPlateData] = useState({
    address: '',
    cabinet_type: '',
    category: '',
    date_completed: '',
    date_logged: '',
    id: '',
    status: '',
    store_name: '',
    tech_name: '',
    ticket_num: '',
    ticket_type: '',
  });

  const [notesID, setNotesID] = useState('x');

  useEffect(() => {
    NoHeaderTableUpdate(
      {
        resource: `/api/r2_repair_tickets_archive`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
      },
      'repair-tickets'
    );
  }, [page, pageSize, sort, filter, updateData, enqNotification, logout]);

  function diffInDaysAndHoursIn(date) {
    const date1 = new Date(date);
    const date2 = new Date();
    let diff = date2 - date1;
    let diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));
    let diffInHours = Math.floor(
      (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    return `${diffInDays} days, ${diffInHours} ${
      diffInHours <= 1 ? 'hour' : 'hours'
    } `;
    // return diffInDays;
  }

  function diffInDaysAndHoursInV2(date, completed = null) {
    const date1 = new Date(date);
    const date2 = completed === null ? new Date() : new Date(completed);
    let diff = date2 - date1;
    let diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));
    let diffInHours = Math.floor(
      (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    return `${diffInDays} ${
      diffInDays === 1 ? 'day' : 'days'
    }, ${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'}`;
    // return diffInDays;
  }

  function diffInDaysAndHours(datIn, completed) {
    return diffInDaysAndHoursInV2(datIn, completed);
  }

  function diffInDays(date, completed = null) {
    let class_name;
    const date1 = new Date(date);
    const date2 = completed === null ? new Date() : new Date(completed);
    const diff = date2 - date1;
    const diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (diffInDays >= 2) {
      class_name = 'hot';
    } else if (diffInDays >= 1) {
      class_name = 'med';
    } else {
      class_name = 'cold';
    }

    return class_name;
  }

  function diffInDaysCSS(datIn, completed) {
    return diffInDays(datIn, completed);
  }

  const [authLevel, setAuthLevel] = useState(false);

  useEffect(() => {
    const checkAuth = localStorage.getItem('type');
    if (checkAuth === 'manager' || checkAuth === 'finance') {
      setAuthLevel(true);
    }
  }, []);

  const definedColumns = [
    {
      field: 'id',
      headerName: 'Ticket Number',
      minWidth: 180,
      flex: 1,
      editable: false,
      valueGetter: (data) =>
        defineTicketNumber(data.ticket_type, data.id, '5', 'R'),
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 180,
      flex: 1,
      editable: false,
      // valueGetter: ({ value }) => ticketStatus(value),
    },
    {
      field: 'ticket_type',
      headerName: 'Ticket Type',
      minWidth: 180,
      flex: 1,
      editable: false,

      // valueGetter: ({ value }) => REPAIR_TICKETTYPES(value),
    },
    {
      field: 'customer_name',
      headerName: 'Store Name',
      minWidth: 190,
      flex: 1,
      editable: false,
    },
    {
      field: 'date_logged',
      headerName: 'Date Logged',
      minWidth: 180,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) => convertDate(value, 0, 10),
    },
    {
      field: 'open',
      headerName: 'Open Time',
      minWidth: 180,
      flex: 1,
      editable: false,
      // valueGetter: ({ row }) => diffInDaysAndHours(row.date_logged),
      renderCell: (data) => (
        <>
          <CircleIcon
            sx={{
              height: '55vh',
              maxWidth: '100%',
              textAlign: 'left',
              color:
                diffInDaysCSS(data.row.date_logged, data.row.date_completed) ===
                'cold'
                  ? 'green'
                  : diffInDaysCSS(
                      data.row.date_logged,
                      data.row.date_completed
                    ) === 'med'
                  ? 'orange'
                  : 'red',
            }}
          />
          <Typography variant='contained' size='small' marginLeft='5px'>
            {diffInDaysAndHours(data.row.date_logged, data.row.date_completed)}
          </Typography>
        </>
      ),
    },
    {
      field: 'date_completed',
      headerName: 'Date Completed',
      minWidth: 150,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) =>
        value === null ? '' : convertDate(value, 0, 10),

      //   valueGetter: checkInWarrantee,
    },

    {
      field: 'customer_category_name',
      headerName: 'Region',
      minWidth: 150,
      flex: 1,
      editable: false,
    },

    {
      field: 'tech_assigned_name',
      headerName: 'Tech Assigned',
      minWidth: 120,
      flex: 1,
      editable: false,
    },

    //Custom "Actions" column - props.value is field value (id in this case)
    {
      // field: 'id',
      headerName: 'Actions',
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: 'left',

      renderCell: (props) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              navigateNew(`/archive/repair_archive_view`, {
                replace: true,
                state: props.row,
              });
            }}
          >
            View
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box
      sx={{
        minHeight: '75vh',
        maxWidth: '100%',
      }}
    >
      {/* <center> */}
      <Box
        // style={{ height: '55vh', maxWidth: '100%', textAlign: 'center' }
        sx={{
          height: '55vh',
          maxWidth: '100%',
          textAlign: 'center',
        }}
      >
        <DataGrid
          sx={ticketTabStyle}
          getRowClassName={(params) => {
            let heatCSS = diffInDaysCSS(params.row.date_logged);
            // if (params.status === 'pendingAuth') {
            //   return 'auth';
            // }
            return params.row.status === 'pending auth' ? 'auth' : heatCSS;
          }}
          rows={data}
          rowCount={totalRows}
          loading={loading}
          pagination
          sortingMode='server'
          filterMode='server'
          // getCellClassName={(params) => {}}
          onSortModelChange={(model) => {
            setPage(0);
            setSort(model);
          }}
          onFilterModelChange={(model) => {
            setPage(0);
            setFilter(model.quickFilterValues);
          }}
          page={page}
          pageSize={pageSize}
          paginationMode='server'
          onPageChange={(newPage) => {
            setPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            setPage(0);
            setPageSize(newPageSize);
          }}
          columns={definedColumns}
          onRowClick={(params) => {
            setActiveRow(params);
            setInfoPlateData(params.row);
            setNotesID(params.row.id);
          }}
          onRowDoubleClick={(params) => {
            navigateNew(`/archive/repair_archive_view`, {
              replace: true,
              state: params.row,
            });
          }}
          rowsPerPageOptions={[20, 50, 100]}
          //   components={{ Toolbar: CustomCustomerToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          //   componentsProps={{
          //     toolbar: {
          //       updateOnclick: () => {
          //         setUpdateData((i) => i + 1);
          //       },
          //     },
          //   }}
        />
      </Box>
      <Box
        style={{
          minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          marginTop: '10px',
          border: 'solid 2px #354775',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid
          container
          //   justifyContent='space-between'
          //   alignItems='center'
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          spacing={0}
        >
          <Grid
            container
            // justifyContent='space-between'
            // alignItems='center'
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            // xs={12}
            // md={12}
            // lg={12}
            spacing={0}
          >
            <Grid container xs={12} md={6} flexDirection='row' rowGap={2}>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Customer:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_name}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Address:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_address}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Telephone Number:
                </Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_contact_number}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Contact Person:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_contact_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container xs={12} md={6} flexDirection='row' rowGap={2}>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Problem/Issue Reported:
                </Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.description}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Date Logged:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {convertDate(infoPlateData.date_logged, 0, 17) !==
                  'Invalid Date'
                    ? convertDate(infoPlateData.date_logged, 0, 17)
                    : ''}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Ticket Logged By:
                </Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.creator_name}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}></Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}></Typography>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              md={12}
              flexDirection='row'
              rowGap={2}
              marginTop='15px'
            >
              <Grid item xs={12} lg={12} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Communication Notes:
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={12}
                rowGap={2}
                sx={{
                  display: notesID === (undefined || 0 || 'x') && 'none',
                }}
              >
                <GlobalNotes relationId={notesID} relationType='ticketTable' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
export default RepairArchive;
